import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorCurrentCloneState = (state: RootState) => state.currentClone;

export const selectorCurrentClone = createSelector(
  selectorCurrentCloneState,
  (currentCloneState) => currentCloneState
);
